import { ScrollReveal } from "./ScrollReveal";
import { Mic, Building2, GraduationCap, PartyPopper, Trophy, Sparkles } from "lucide-react";

const offers = [
  {
    icon: Mic,
    title: "Stand-up",
    description: "Profesjonalny występ stand-upowy dopasowany do charakteru Twojej firmy. Gwarantujemy świetną zabawę i pozytywne emocje.",
    items: ["Występ 45-60 minut", "Materiał dostosowany do odbiorców", "Interakcja z publicznością"],
    gradient: "from-brand-purple/10 to-brand-magenta/5",
    iconColor: "text-brand-purple",
  },
  {
    icon: Building2,
    title: "Eventy firmowe",
    description: "Kompleksowa obsługa eventów firmowych z elementami komediowymi. Idealne na integracje i wydarzenia specjalne.",
    items: ["Prowadzenie eventu", "Skecze i scenki", "Konkursy z humorem"],
    gradient: "from-brand-magenta/10 to-brand-orange/5",
    iconColor: "text-brand-magenta",
  },
  {
    icon: GraduationCap,
    title: "Szkolenia",
    description: "Szkolenia z elementami humoru, które uczą i bawią jednocześnie. Efektywna nauka przez śmiech.",
    items: ["Warsztaty team building", "Ćwiczenia integracyjne", "Praktyczne zadania"],
    gradient: "from-brand-orange/10 to-brand-cyan/5",
    iconColor: "text-brand-orange",
  },
  {
    icon: PartyPopper,
    title: "Imprezy prywatne",
    description: "Profesjonalna oprawa komediowa imprez prywatnych. Idealne na urodziny, wesela i inne okazje.",
    items: ["Występy dedykowane", "Roasty okolicznościowe", "Prowadzenie imprez"],
    gradient: "from-brand-cyan/10 to-brand-purple/5",
    iconColor: "text-brand-cyan",
  },
  {
    icon: Trophy,
    title: "Gale i konferencje",
    description: "Profesjonalne prowadzenie gal i konferencji z elementami humoru. Elegancja połączona z rozrywką.",
    items: ["Prowadzenie ceremonii", "Przerywniki komediowe", "Dostosowany format"],
    gradient: "from-brand-purple/10 to-brand-cyan/5",
    iconColor: "text-brand-purple",
  },
  {
    icon: Sparkles,
    title: "Comedy Show",
    description: "Kompleksowy program rozrywkowy łączący różne formy komedii. Pełen wieczór śmiechu i zabawy.",
    items: ["Mix form komediowych", "2-3 godziny programu", "Różni wykonawcy"],
    gradient: "from-brand-magenta/10 to-brand-purple/5",
    iconColor: "text-brand-magenta",
  },
];

export const Offer = () => {
  return (
    <section id="oferta" className="py-24 md:py-32 bg-gray-50/50">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            Nasza <span className="gradient-text">oferta</span>
          </h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {offers.map((offer, i) => {
            const Icon = offer.icon;
            return (
              <ScrollReveal key={offer.title} delay={i * 0.1}>
                <div className={`modern-card group bg-gradient-to-br ${offer.gradient} h-full`}>
                  <div className={`w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className={`w-7 h-7 ${offer.iconColor}`} />
                  </div>
                  <h3 className="text-xl font-montserrat font-bold mb-3 text-primary">{offer.title}</h3>
                  <p className="text-gray-600 mb-5 text-sm leading-relaxed">{offer.description}</p>
                  <ul className="space-y-2">
                    {offer.items.map((item) => (
                      <li key={item} className="text-sm text-gray-500 flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-brand-purple/40" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
